import { render } from "./packageList.vue?vue&type=template&id=c879a41e&scoped=true"
import script from "./packageList.vue?vue&type=script&lang=js"
export * from "./packageList.vue?vue&type=script&lang=js"

import "./packageList.vue?vue&type=style&index=0&id=c879a41e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c879a41e"

export default script